<form #target1 [hidden]="hide">

    <div>
        <div class="card-body">
            <input class="form-control" type="text" [placeholder]="'Téléphone: '+item?.phone"
                aria-label="Disabled input example" disabled>
            <input style="margin-top:23px" class="form-control" type="text" [placeholder]="'Email: '+item?.email"
                aria-label="Disabled input example" disabled>
            <input style="margin-top:23px" class="form-control" type="text" [placeholder]="'Raison: '+item?.reason"
                aria-label="Disabled input example" disabled>
        </div>
    </div>
</form>

<div class="courses-area ">
    <div class="container">

        <div class="row pb-100">



            <div class="container">

                <div class="row h-100 justify-content-center align-items-center">
                    <div class="container">


                        <div *ngIf="showSpinner" class="d-flex align-items-center justify-content-center">
                            <span style="color:#9b215c" class="spinner-border spinner"></span>
                        </div>

                        <div class="row h-100 justify-content-center align-items-center">

                            <div class="col-sms-12 col-lg-7 col-md-7">

                                <form>

                                    <div class="row no-gutters align-items-center spec">
                                        <div class="col">
                                            <div class="card-grid">
                                                <div class="card">
                                                    <div class="card-content">
                                                        <div class="card-text">

                                                            <button pButton (click)="sendEmail($event)" style="    background-color: #eeeeeea1 !important;
                                                    border-color: #9b215c;" class="btn btn-success btn-sm">
                                                                Envoyer le mail <span
                                                                    *ngIf="elementSelected?.showSpinner"
                                                                    class="spinner-border spinner"></span>
                                                            </button>

                                                            <!-- <button [disabled]="!isChangedItems  || spinnerShare" (click)="share()" style="cursor:pointer;margin-bottom: 23px;background-color:white!important;
                                                            color:black;border-width: 3px;font-weight:bold;border-color: #9b215c;"
                                                                class="btn btn-success btn-sm">
                                                                <img *ngIf="!spinnerShare" src="assets/img/share.png" width="25" /><span
                                                                    style="margin-left: 10px;">Partager</span>
                                                                <span *ngIf="spinnerShare" style="height: 19px;
                                                                    width: 19px;
                                                                    margin-left: 13px;" class="spinner-border spinner"></span>
                                                            </button> -->


                                                        </div>
                                                        <div class="card-image">
                                                            <img src="assets/img/courses/request.svg" alt="image">
                                                        </div>
                                                    </div>

                                                    <div class="row ">
                                                        <div *ngFor="let user of users | paginate: { itemsPerPage: count, currentPage: p }; let i=index"
                                                            class="col-xl-6  col-sm-12 mb-4 d-flex justify-content-center">

                                                            <div class="cardText lesson w-100">
                                                                <div class="card-body">
                                                                    <h5 class="card-title"
                                                                        style="font-weight: bold;color: var(--bs-black) ;font-size: 14px;">
                                                                        {{user.name}} {{user.firstname}}</h5>
                                                                    <h6 class="card-subtitle mb-2 text-muted"
                                                                        style="font-size: 12px;">
                                                                        {{user?.date}}</h6>

                                                                    <div class="d-flex justify-content-end"
                                                                        style="cursor:pointer">
                                                                        <div class="p-2 customStrah">

                                                                            <i *ngIf="user?.inscriptionConfirmed"
                                                                                (click)="pop(user)" style="font-size: 23px;color: green;position: relative;
                                                                top: -3.8px;" class="fa fa-info-circle"
                                                                                aria-hidden="true"></i>
                                                                        </div>

                                                                        <div class="p-2 customStrah"
                                                                            style="cursor:pointer">

                                                                            <i *ngIf="!user?.inscriptionConfirmed"
                                                                                (click)="pop(user)" style="font-size: 23px;color: #9b215c;margin-left: 1px;position: relative;
                                                                top: -3.8px;" class="fa fa-info-circle"
                                                                                aria-hidden="true"></i>
                                                                        </div>

                                                                        <div class="p-2 customStrah"
                                                                            *ngIf="!user?.inscriptionConfirmed">
                                                                            <input style="position: relative;
                                                                top: -3.8px;" class="form-check-input"
                                                                                [checked]="user.selected"
                                                                                type="checkbox"
                                                                                (change)="user.selected=!user.selected;changeSelection(user)"
                                                                                name="checkbox-list" [attr.id]="i">
                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                    <div *ngIf="!showSpinner  " class="d-flex justify-content-end">
                                        <pagination-controls previousLabel="" nextLabel="" (pageChange)="p = $event">
                                        </pagination-controls>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div style="margin-top:40px" *ngIf="showSpinner  "
                        class="d-flex align-items-center justify-content-center">
                        <span style="color:#9b215c" class="spinner-border spinner"></span>
                    </div>
                </div>
            </div>


            <!-- <form>
                <div style="cursor:pointer;margin-top:32px" class="cart-table table-responsive">
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col">
                                    <span> Nom(s) & Prénom(s)</span>

                                </th>
                                <th scope="col">
                                    <span style="margin-left: 23px;">Date de la demande</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <div class="empty" *ngIf="!showSpinner && (!users || users?.length==0)"> Aucune demande de
                                pré-inscription en cours...</div>

                            <tr (click)="selectItem(user)" [ngClass]="{itemColor:isSelected(user)}"
                                *ngFor="let user of users" class="product-name">

                                <td class="product-price" style="margin-left: 10px;">
                                    <span class="unit-amount">{{user.name}} {{user.firstname}}</span>
                                </td>

                                <td class="product-price">

                                    <span style="margin-left: 23px;" class="unit-amount">{{user?.date}}</span>
                                </td>

                                <td class="product-price" (click)="pop(user)">

                                    <i *ngIf="user?.inscriptionConfirmed" style="color: green;"
                                        class="fa fa-info-circle" aria-hidden="true"></i>
                                    <i *ngIf="!user?.inscriptionConfirmed" style="color: #9b215c;"
                                        class="fa fa-info-circle" aria-hidden="true"></i>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </form> -->
        </div>
    </div>
</div>